
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { LoadingSpinner } from "@/components/loading/LoadingSpinner";
import { School } from "@/hooks/data/useSchools";

interface DeleteSchoolDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  school: School | null;
  onConfirm: () => void;
  isDeleting?: boolean;
}

const DeleteSchoolDialog = ({ 
  open, 
  onOpenChange, 
  school, 
  onConfirm,
  isDeleting = false
}: DeleteSchoolDialogProps) => {
  const handleConfirmDelete = () => {
    onConfirm();
    if (!isDeleting) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={isDeleting ? () => {} : onOpenChange}>
      <AlertDialogContent dir="rtl">
        <AlertDialogHeader className="bg-red-50 p-4 rounded-t-lg -mx-6 -mt-6 mb-4">
          <AlertDialogTitle className="text-red-600 text-right">
            تأكيد حذف المدرسة
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription className="text-gray-700 text-right">
          هل أنت متأكد من رغبتك في حذف مدرسة <strong>"{school?.school_name}"</strong>؟
          <br />
          <br />
          <span className="text-red-600 font-medium">
            تحذير: سيتم حذف جميع البيانات المرتبطة بهذه المدرسة نهائياً:
          </span>
          <ul className="list-disc list-inside mt-2 text-sm">
            <li>جميع الطلاب المسجلين</li>
            <li>جميع الفصول الدراسية</li>
            <li>جميع سجلات الحضور</li>
            <li>جميع إعدادات المدرسة</li>
            <li>حساب المدرسة في النظام</li>
          </ul>
          <br />
          <strong className="text-red-600">هذا الإجراء لا يمكن التراجع عنه!</strong>
        </AlertDialogDescription>
        <AlertDialogFooter className="gap-2">
          <AlertDialogCancel 
            disabled={isDeleting}
            className="bg-gray-200 text-gray-800 hover:bg-gray-300 disabled:opacity-50 min-w-[140px]"
          >
            إلغاء
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirmDelete}
            disabled={isDeleting}
            className="bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 min-w-[140px] flex items-center justify-center gap-2"
          >
            {isDeleting ? (
              <>
                <LoadingSpinner size="sm" />
                جاري الحذف...
              </>
            ) : (
              "حذف المدرسة نهائياً"
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteSchoolDialog;
